import React from 'react';

export const ADMIN_DASHBOARD_TABS = [
  { id: 'overview', label: '📊 Visão Geral' },
  { id: 'projects', label: '📁 Projetos' },
  { id: 'analytics', label: '📈 Análises' },
];

export const AdminDashboardTabs = ({ activeTab, onChangeTab }) => {
  return (
    <div className="flex gap-2 mb-6" data-testid="admin-dashboard-tabs">
      {ADMIN_DASHBOARD_TABS.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onChangeTab(tab.id)}
          className={`px-4 py-2 rounded-lg font-medium transition ${
            activeTab === tab.id ? 'bg-blue-600 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'
          }`}
          data-testid={`admin-dashboard-tab-${tab.id}`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};
